module.exports = __webpack_public_path__ + "img/bench_by_banhji.0f53bd06.png";